function mimeFromUrl(imageUrl: string): string {
    const ext = imageUrl.split('?')[0].split('.').pop()?.toLowerCase();

    switch (ext) {
        case 'jpg':
        case 'jpeg':
            return 'image/jpeg';
        case 'webp':
            return 'image/webp';
        case 'png':
        default:
            return 'image/png';
    }
}

function mirrorImageHorizontally(imageUrl: string): Promise<string> {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext('2d');

            if (!ctx) {
                reject(new Error('Не удалось получить контекст canvas'));
                return;
            }

            ctx.translate(canvas.width, 0);
            ctx.scale(-1, 1);
            ctx.drawImage(img, 0, 0);

            const mime = mimeFromUrl(imageUrl);
            const quality = mime === 'image/jpeg' ? 0.92 : undefined;

            resolve(canvas.toDataURL(mime, quality));
        };
        img.onerror = () => reject(new Error('Ошибка загрузки изображения для отражения'));
        img.src = imageUrl;
    });
}

export function mirrorImage(originalUrl: string): Promise<string> {
    return mirrorImageHorizontally(originalUrl);
}
